module.exports = __webpack_public_path__ + "img/pic_xishouye2.5d755abb.png";